import BaseComponent from "../components/BaseComponent";
import BaseApi from "../api/BaseApi";
import {
    Button, ButtonGroup,
    Cell,
    Div, Input,
    List,
    RichCell,
    Search,
    SimpleCell,
    Spinner,
    SplitCol,
    SplitLayout,
    Switch,
    Textarea
} from "@vkontakte/vkui";
import React from "react";
import KBInput from "../assets/KBInput";
import {AdaptivityContext, setQuizStep} from "../assets/constants";

class AdditionalProducts extends BaseComponent {


    state = {
        items: [],
        search: '',
        loading: false
    }

    constructor(props) {
        super(props);

    }

    componentDidMount() {
        super.componentDidMount()
        this.getItems()
    }

    getItems = () => {

        if(this.props.current_item.additionalItems && this.props.current_item.additionalItems.length > 0){
            this.setState({items:this.props.current_item.additionalItems})
        } else {

            BaseApi.post('/?app=partnersproducts&act=getPartnerProductsAdditional',
                {
                    product_id: this.props.product.id,
                    width: this.props.width
                }).then(data => {
                    const {results} = data.data

                    if(results && Array.isArray(results)) {
                        this.setState({items: results})
                    }
                })
        }
    }

    render() {
        setTimeout(() => this.noRender = false, 500)
        const widthComment = '150px'
        const P = this.props.width *2 + this.props.length *2
        return <SplitLayout style={{marginBottom: "150px"}}>
            <SplitCol>
                <Div className={AdaptivityContext.isMobile?"action-board":""}>
                    <ButtonGroup mode="horizontal" stretched style={{justifyContent: 'end'}}>

                        <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                style={{maxWidth: '50%'}}
                                onClick={() => this.props.closeAdditionals()}>Отмена</Button>

                        <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                style={{maxWidth: '50%'}}
                                onClick={() => this.props.setAdditionals(this.state.items)}>Сохранить</Button>
                    </ButtonGroup>
                </Div>
                <Search placeholder="Введите номер ниток" value={this.state.search}
                        onChange={e => this.setState({search: e.currentTarget.value})}/>

                <List className="additonal-products_list">
                    {this.state.loading &&
                        <Cell before="Получаем список услуг" after={<Spinner size="large"/>}></Cell>}
                    {this.state.items && Array.isArray(this.state.items) && this.state.items.map((item, index) =>


                        item.name.indexOf(this.state.search) !== -1 &&
                        <RichCell Component="label" multiline key={"additionalProductsItem" + index}

                                  after={<div className="additonal-products_swithers-wrapper">
                                      {item.need_ost?
                                          [
                                              <Div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                                  <small>Периметр: {P}м</small>
                                                  <Button size="s" mode="outline" style={{width: '100px', fontSize: '8px'}}
                                                            onClick={() => this.setQnt(index, P)}
                                                  >Весь отрез</Button>
                                                  <Input value={this.noRender ? item.qnt: item.qnt * 1}
                                                         placeholder="Количество"
                                                            style={{width: '100px'}}
                                                         onChange={e => this.setQnt(index, e.currentTarget.value)}/>

                                              </Div>,
                                              <Textarea value={item.comment}
                                                     placeholder="Комментарий"
                                                     style={{width: AdaptivityContext.isMobile?widthComment:'inherit'}}
                                                     onChange={e => this.setComment(index, e.currentTarget.value)}/>
                                          ]:
                                          [<Switch size={10} checked={item.checked} style={{marginRight:'10px'}}
                                              onChange={() => this.toggleItem(index)}/>,
                                      <Textarea value={item.comment}
                                             placeholder="Комментарий"
                                             style={{width: AdaptivityContext.isMobile?widthComment:'inherit'}}
                                             onChange={e => this.setComment(index, e.currentTarget.value)}/>]
                                         }
                                  </div>}
                        >

                            <div style={{width: '150px'}}>{item.name}</div>
                        </RichCell>
                    )}
                </List>

            </SplitCol>
        </SplitLayout>

    }

    toggleItem = (index) => {
        const old = this.state.items[index]
        old.checked = !old.checked
        const items = this.state.items
        items[index] = old
        this.setState({items})
    }

    setComment = (index, value) => {
        const old = this.state.items[index]
        old.comment = value
        const items = this.state.items
        items[index] = old
        this.setState({items})
    }
    setQnt = (index, value_) => {
        const old = this.state.items[index]

        let value = value_.toString().replace(',', '.')
        const match = value.match('([0-9]+[\.\,]?([0-9]{1,3})?)')
//        console.log(match)
        if (value !== '') {
            if (!match || value * 1 == 0) return
        }
        let qnt = match ? match[0] : '';

        this.noRender = true
        old.qnt = qnt
        const items = this.state.items
        items[index] = old
        this.setState({items})
    }


}

export default AdditionalProducts